import request from "../request";

import { REACT_BASE_URL_GAMA_USERS } from "../url";

export const createRequest = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/requests`,
    method: "POST",
    data,
  });
};

export const getAllRequests = async (filters, page = 1, query) => {
  console.log(query, "REQUESTS");
  const queryParams = new URLSearchParams(filters).toString();
  return await request({
    url:
      `${REACT_BASE_URL_GAMA_USERS}/requests?page=${page}&orderByProperty=${
        query?.orderByProperty || "id"
      }&orderBy=${query?.orderBy || "DESC"}&` + queryParams,
    method: "GET",
  });
};

export const updateRequest = async (requestId, data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/requests/${requestId}`,
    method: "PATCH",
    data: data,
  });
};

export const deleteRequest = async (requestId) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/requests/${requestId}`,
    method: "DELETE",
  });
};
